let platforms = null;
let req = null;
let rejectQueue = [];
let resolveQueue = [];

/**
 * Fetch platforms
 *
 * Restricts to a single call per page load, will resolve with the platforms
 * whenever it’s returned
 *
 * @return {Promise}
 */
export default function fetchPlatforms() {
  return new Promise((resolve, reject) => {
    if (platforms) {
      resolve(platforms);
    } else {
      rejectQueue.push(reject);
      resolveQueue.push(resolve);

      if (!req) {
        req = fetch("/platforms.json", {
          method: "GET",
          credentials: "same-origin",
          headers: {
            accept: "application/json"
          }
        })
          .then(response => {
            // Throw a custom error message
            if (!response.ok) {
              rejectQueue.forEach(cb =>
                cb(console.log("Failed to load platforms", response))
              );
            } else {
              return response.json();
            }
          })
          .then(data => {
            platforms = data;
            resolveQueue.forEach(cb => cb(platforms));
          });
      }
    }
  });
}
